import * as React from 'react';
import styles from './Footer.css';
import { useDispatch } from 'react-redux';
import { Link, useLocation, matchPath } from 'react-router-dom';
import { SocialBar } from '../socialbar';
import { changeContactFormAction } from '../../ducks';
import { FOOTER } from '../../lib/labels';

export const Footer = ({ routes }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  
  const { match, route: { disableFooter } } = routes
    .map(route => ({ match: matchPath(location.pathname, { ...route, exact: true }), route }))
    .find(x => x.match) || { route: {} };

  if (match && disableFooter && disableFooter(match.path)) {
    return null;
  }
  return (
    <footer className={styles.hideFooterClass}>
      <div className={'container'}>
        <SocialBar />
        <div>
          <a href="https://www.mediahuis.nl/privacy"
            target="_blank"
            rel="noopener noreferrer">
            {FOOTER.PRIVACY}
          </a>
            &nbsp;|&nbsp;
          <a
            href="https://assets.dumpert.nl/algemene-gebruiksvoorwaarden-dtmedia.pdf"
            rel="noopener noreferrer"
            target="_blank"
          >
            {FOOTER.CONDITIONS}
          </a>
            &nbsp;|&nbsp;
          <Link to="/huisregels">{FOOTER.HOUSERULES}</Link>
            &nbsp;|&nbsp;
          <div
            className={styles.navitem}
            onClick={() => dispatch(changeContactFormAction(true))}
          >
            {FOOTER.CONTACT}
          </div>
            &nbsp;|&nbsp;
          <a href="https://api-live.dumpert.nl/mobile_api/json/rss"
            className={styles.navitem}
            target="_blank"
            rel="noopener noreferrer">
            {FOOTER.RSS}
          </a>
        </div>
      </div>
    </footer>    
  );
};
